import { useState } from 'react';
import type { MediaAsset } from '../data/gallery';

export type GalleryLabels = {
  next: string;
  previous: string;
};

type Props = {
  media: MediaAsset[];
  title: string;
  labels: GalleryLabels;
};

const ArtworkGallery = ({ media, title, labels }: Props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const total = media.length;

  if (total === 0) {
    return null;
  }

  const goNext = () => setActiveIndex((index) => (index + 1) % total);
  const goPrev = () => setActiveIndex((index) => (index - 1 + total) % total);

  const currentImage = media[activeIndex];

  return (
    <div className="artwork-gallery">
      <div className="artwork-gallery__viewer">
        <button type="button" onClick={goPrev} aria-label={labels.previous} className="gallery-nav gallery-nav--prev">
          ‹
        </button>
        <figure>
          <img src={currentImage.url} alt={`${title} ${activeIndex + 1}/${total}`} />
        </figure>
        <button type="button" onClick={goNext} aria-label={labels.next} className="gallery-nav gallery-nav--next">
          ›
        </button>
      </div>
      <div className="artwork-gallery__thumbnails" role="list">
        {media.map((image, index) => (
          <button
            key={`${image.url}-${index}`}
            type="button"
            onClick={() => setActiveIndex(index)}
            className={`thumbnail${index === activeIndex ? ' thumbnail--active' : ''}`}
            aria-current={index === activeIndex}
          >
            <img src={image.url} alt={`${title} thumbnail ${index + 1}`} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ArtworkGallery;
